export class AvailableSofaglideModel {
    crossSellingProductCode: string;
    baseProductCode: string;
}